export default "__VITE_ASSET__CoMlyqPT__"